import { api } from 'app/api';
import { ApiResponse, LaborSubclassDto, LaborSubclassesParameters } from 'dtos';
import { URIQuery } from 'utils';

export const getLaborSubclasses = async (parameters: LaborSubclassesParameters): Promise<ApiResponse<LaborSubclassDto[]>> =>
  await api.get('labor-subclasses' + URIQuery(parameters)).then(res => res.data);

export const getAllLaborSubclasses = async (jobNumber?: string): Promise<ApiResponse<LaborSubclassDto[]>> => {
  let url = 'labor-subclasses/all';

  if (jobNumber) {
    url += `?jobNumber=${encodeURIComponent(jobNumber)}`;
  }

  return await api.get(url).then(res => res.data);
};

export const createLaborSubclass = async (values: LaborSubclassDto): Promise<ApiResponse<LaborSubclassDto>> =>
  await api.post('labor-subclasses', values).then(res => res.data);

export const updateLaborSubclass = async (values: LaborSubclassDto): Promise<ApiResponse<LaborSubclassDto>> =>
  await api.put('labor-subclasses', values).then(res => res.data);
